import { styled } from '@mui/material/styles';
import type { CSSProperties } from 'react';

interface CardProps {
  verticalAlign?: CSSProperties['justifyContent'];
  horizontalAlign?: CSSProperties['alignItems'];
  maxWidth?: string;
  width?: string | number;
  padding?: string;
  borderRadius?: string;
}

export const Container = styled('div')<CardProps>(
  ({
    theme,
    verticalAlign = 'flex-start',
    horizontalAlign = 'flex-start',
    padding = '24px',
    width = '100%',
    maxWidth = '100%',
    borderRadius = '24px',
  }) => `
  position: relative;
  z-index: 1;
  padding: ${padding};
  border-radius: ${borderRadius};
  display: flex;
  flex-direction: column;
  justify-content: ${verticalAlign};
  align-items: ${horizontalAlign};
  color: ${theme.palette.text.primary};
  width: ${width};
  max-width: ${maxWidth};
  box-sizing: border-box;

  backdrop-filter: ${
    theme.palette.mode === 'dark' ? 'blur(20px)' : 'blur(14px) saturate(120%)'
  };
  -webkit-backdrop-filter: ${
    theme.palette.mode === 'dark' ? 'blur(20px)' : 'blur(14px) saturate(120%)'
  };

  background: ${
    theme.palette.mode === 'dark'
      ? 'linear-gradient(145deg, rgba(42, 52, 77, 0.85) 0%, rgba(0, 207, 255, 0.12) 100%)'
      : 'rgba(255, 255, 255, 0.6)'
  };

  border: ${
    theme.palette.mode === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.08)'
      : '1px solid rgba(255, 255, 255, 0.4)'
  };

  box-shadow: ${
    theme.palette.mode === 'dark'
      ? '0 8px 32px rgba(0, 0, 0, 0.5)'
      : '0 4px 12px rgba(0, 0, 0, 0.04), 0 1px 4px rgba(0, 0, 0, 0.02)'
  };
`
);

export const CardHeader = styled('div')`
  width: 100%;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
  align-items: center;
  display: flex;
  gap: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
`;
